import Visa from '../icons/Visa blue.svg';
import Master from '../icons/mastercard.svg';
import Blik from '../icons/blik.svg';
import Transfer from '../icons/przelewy.svg';
import TransferCZ from '../icons/bank_cs.svg';
import Paypal from '../icons/paypal.svg';
import ApplePay from '../icons/applepay.png';
import GooglePay from '../icons/googlepay.svg';

export const PAYMENTS_INFO_CONFIG = [
	{
		image: Blik,
		width: '30px',
		langs: ['pl'],
	},
	{
		image: Visa,
		width: '30px',
		langs: [
			'pl',
			'cs',
			'es',
			'bg',
			'de',
			'es',
			'et',
			'hr',
			'it',
			'ro',
			'sk',
			'hu',
			'el',
			'sl',
			'id',
			'sv',
			'br-pt',
			'kr-ko',
			'lt',
			'et',
		],
	},
	{
		image: Master,
		width: '20px',
		langs: [
			'pl',
			'cs',
			'es',
			'bg',
			'de',
			'es',
			'et',
			'hr',
			'it',
			'ro',
			'sk',
			'el',
			'hu',
			'en',
			'sl',
			'id',
			'sv',
			'br-pt',
			'kr-ko',
			'lt',
			'et',
		],
	},
	{
		image: Transfer,
		width: '45px',
		langs: ['pl'],
	},
	{
		image: TransferCZ,
		width: '50px',
		langs: [''],
	},
	{
		image: ApplePay,
		width: '30px',
		langs: [
			'es',
			'bg',
			'de',
			'es',
			'et',
			'hr',
			'it',
			'ro',
			'sk',
			'cs',
			'el',
			'en',
			'sl',
			'id',
			'sv',
			'br-pt',
			'kr-ko',
			'lt',
			'et',
		],
	},
	{
		image: GooglePay,
		width: '50px',
		langs: [
			'es',
			'bg',
			'de',
			'es',
			'et',
			'hr',
			'it',
			'ro',
			'sk',
			'cs',
			'el',
			'en',
			'sl',
			'id',
			'sv',
			'br-pt',
			'kr-ko',
			'lt',
			'et',
		],
	},
	{
		image: Paypal,
		width: '50px',
		langs: [
			'es',
			'de',
			'et',
			'hr',
			'it',
			'cs',
			'el',
			'en',
			'sl',
			'sv',
			'br-pt',
			'kr-ko',
			'lt',
			'et',
		],
	},
];
